/**
 * Sovereign Platform Temporal API Client
 * Wraps @homy/api-client platformClient for Temporal scheduled jobs & workflows.
 */

import { platformClient } from "@homy/api-client";

/**
 * Get Temporal cluster health and schedule metrics summary.
 * @returns {Promise<{clusterHealth: string, status: string, activeSchedulesCount: number, failureRate: number}>}
 */
export async function getTemporalSummary() {
  const response = await platformClient.get("/temporal/summary");
  return response.data;
}

/**
 * List all recurring workflows and schedules.
 * @returns {Promise<{schedules: Array<{id: string, workflowType: string, cron: string, nextRun: string, lastState: string, lastRunAt: string, failureCount: number, paused: boolean}>}>}
 */
export async function getTemporalSchedules() {
  const response = await platformClient.get("/temporal/schedules");
  return response.data;
}

/**
 * Manually trigger a scheduled workflow execution.
 * @param {string} scheduleId
 * @returns {Promise<{success: boolean, message: string}>}
 */
export async function triggerTemporalSchedule(scheduleId) {
  const response = await platformClient.post(`/temporal/schedules/${scheduleId}/trigger`);
  return response.data;
}

/**
 * Pause or resume a recurring workflow schedule.
 * @param {string} scheduleId
 * @returns {Promise<{success: boolean, paused: boolean}>}
 */
export async function pauseTemporalSchedule(scheduleId) {
  const response = await platformClient.post(`/temporal/schedules/${scheduleId}/pause`);
  return response.data;
}

export const temporalApi = {
  getTemporalSummary,
  getTemporalSchedules,
  triggerTemporalSchedule,
  pauseTemporalSchedule,
};

export default temporalApi;
